import React from "react";
import {
  Box,
  Button,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

// import dashboard from "../../../../Images/OJT/dashboard.png";
// import userTraining from "../../../../Images/OJT/userTraining.png";
// import trainerTraining from "../../../../Images/OJT/trainerTraining.png";
// import wave from "../../../../Images/aboutUsBg.jpg";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { Done } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const OJT = () => {
  const navigate = useNavigate();
  return (
    <Grid2 container spacing={"2rem"}>
      <WaveBackground
        menu={"Our Products"}
        title={"Online Job Training"}
        description={
          "Streamlining employee training for efficiency and growth."
        }
      />

      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
          mt="-10%"
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <img
              src={"/Images/OJT/dashboard.png"}
              alt="OJT dashboard"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                textAlign: { xs: "center", md: "left" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Job Training Management Web App
            </Typography>
            <Typography
              variant="h1"
              sx={{
                letterSpacing: 0.3,
                lineHeight: 1.5,
                fontWeight: 300,
                fontFamily: "inherit",
                fontSize: "20px",
                mt: "1rem",
              }}
            >
              A{" "}
              <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                OJT
              </span>{" "}
              is a comprehensive platform designed to facilitate the seamless
              management of employee training programs. The app allows
              organizations to plan, track, and evaluate the effectiveness of
              training sessions, helping employees build the necessary skills to
              perform their jobs efficiently.{" "}
            </Typography>

            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: 700,
                fontFamily: "inherit",
                mt: 4,
              }}
            >
              Key Features
            </Typography>
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Training Program Scheduling</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Course Creation and Cataloging</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Employee Progress Tracking</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Resource Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Automated Reminders and Notifications
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Customizable Dashboards</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>User Management</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        container
        justifyContent={"center"}
        sx={{ background: commonCss.backgroundGray }}
      >
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem" },
            maxWidth: { xs: "auto", md: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pl: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              It enables administrators to plan, organize, track, and evaluate
              training sessions efficiently, while also providing employees with
              easy access to training schedules, progress tracking, and
              certification management.
            </Typography>
            <Typography
              variant="h1"
              sx={{
                letterSpacing: 0.3,
                lineHeight: 1.5,
                fontWeight: 300,
                fontFamily: "inherit",
                fontSize: "20px",
                mt: "1rem",
              }}
            >
              Why Use OJT?
            </Typography>

            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 4,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Employees learn by doing, gaining hands-on experience.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Tailored to the specific needs of the job and organization.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  {" "}
                  Real-world practice reinforces skills and boosts confidence.
                </ListItemText>
              </ListItem>
            </List>
          </Grid2>
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-end" }}
          >
            <img
              src={"/Images/OJT/userTraining.png"}
              alt="OJT user training screen"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <img
              src={"/Images/OJT/trainerTraining.png"}
              alt="OJT trainer training screen"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Benefits
            </Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1.1rem",
                  fontWeight: 400,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Centralized training management for better organization.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Real-time tracking and analytics to monitor progress.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Streamlined communication through notifications and alerts.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Comprehensive reporting for performance evaluation.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Reminders for upcoming training sessions and deadlines.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Interactive dashboards</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        size={12}
        container
        justifyContent={"flex-end"}
        sx={{ p: "0rem 2rem 2rem 0rem", width: { xs: "auto", xl: "2000px" } }}
      >
        <Button
          sx={{
            backgroundColor: commonCss.buttonBg,
            color: commonCss.buttonText,
            padding: "0.5rem 2rem",
            textTransform: "none",
            width: "fit-content",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: "30px",
            ":hover": {
              background: commonCss.blue,
            },
            //  position: 'relative',
            //   transition: '0.3s',
            //     animation: 'glow 1.5s infinite alternate',

            //   '@keyframes glow': {
            //     '0%': {
            //       background: "#FCAE1E",
            //     },
            //     '100%': {
            //       background: commonCss.blue,
            //     },
            //   },
          }}
          onClick={() => {
            navigate("/products?productName=ojt");
          }}
        >
          Explore More Products
        </Button>
        <Button
          sx={{
            backgroundColor: commonCss.buttonBg,
            color: commonCss.buttonText,
            padding: "0.5rem 2rem",
            textTransform: "none",
            width: "fit-content",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: "30px",
            ":hover": {
              background: commonCss.blue,
            },
            position: "relative",
            transition: "0.3s",
            animation: "glow 1.5s infinite alternate",

            "@keyframes glow": {
              "0%": {
                background: "#FCAE1E",
              },
              "100%": {
                background: commonCss.blue,
              },
            },
          }}
          onClick={() => {
            navigate("/contactus?type=Product Demo&&demo=Online Job Training");
          }}
        >
          Schedule a Demo
        </Button>
      </Grid2>
    </Grid2>
  );
};

export default OJT;
